import { h, resolveComponent } from 'vue'

const DetalleCentro = () => import('@/app/views/centros/views/DetalleCentro');


const centrosRoutes = [
  {
    path: 'centros',
    name: 'Centros',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      }
    },
    meta: {
      breadcrumb: {
        title: 'GLOBAL.BREADCRUMBS.centros' // Clave de traducción para el breadcrumb principal
      }
    },
    children: [
      {
        path: 'yo',
        name: 'centro:Detalle',
        component: DetalleCentro,
        meta: {
          auth: true,
          entidad: 'centros',
          breadcrumb: {
            title: "GLOBAL.BREADCRUMBS.detalle"
          }
        },
      }
    ]
  }
];

export default centrosRoutes;
